<template>
	<section class="transactions section section--mini">
		<Withdrawal :withdrawal="item" v-for="item in items" :key="item.id" />
	</section>
</template>
<script lang="ts" setup>
import "./WithdrawalsView.scss";
import {computed, onMounted, ref, watch} from "vue";
import WithdrawalEntity from "@/entities/WithdrawalEntity";
import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {useApiStore} from "@/stores/apiStore";
import Withdrawal from "@/components/Withdrawal/Withdrawal.vue";

interface Props{
	orderBy : 'asc' | 'desc'
}

let {api} = useApiStore();

let props = withDefaults(defineProps<Props>(), {
	orderBy: 'desc'
});

let items = ref<WithdrawalEntity[]>([]);
let loading = ref<boolean>(false);

async function loadWithdrawals(){

	loading.value = true;

	let withdrawals = await api.getWithdrawals(1, 100, {
		mode : props.orderBy,
		field : 'id'
	});

	items.value = withdrawals.items;
	loading.value = false;

}

onMounted(loadWithdrawals);
watch(() => props.orderBy, loadWithdrawals);

</script>